/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import {
  AbstractSnapshotFormComponent,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { JobSpecInfo } from '../../../resources/job.model';
import { ContactDetailsDialogConfig, contactDetailsDialogRoute } from '@gh/builder-shared';
import { ContactType } from '@gh/builder-shared-data';
import { filter$ } from '@gh/rx/operators';
import { DialogService, setControlValue } from '@gh/core-ui';

@Component({
  standalone: false,
  selector: 'gh-job-spec-top-form',
  templateUrl: 'job-spec-top-form.component.html',
  styleUrls: ['./job-spec-top-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobSpecTopFormComponent extends AbstractSnapshotFormComponent<JobSpecInfo> {
  @Output() previewClick: EventEmitter<boolean> = new EventEmitter();
  @Output() contactMenuChange: EventEmitter<void> = new EventEmitter();

  constructor(private formStateBuilder: FormStateBuilder,
              private dialogService: DialogService) {
    super();
  }

  onPreview(): void {
    this.previewClick.emit();
  }

  openContact(): void {
    this.dialogService.openWithInput(contactDetailsDialogRoute, <ContactDetailsDialogConfig>{
      contactType: ContactType.Customer,
      contactId: this.state.value.contactId,
      parentTitle: 'lbl_job',
    }).afterClosed().pipe(
      filter$(Boolean))
      .subscribe((contact: any) => {
        // Emit event to indicate contact menu change before updating form
        this.contactMenuChange.emit();
        this.state.value.contactId = contact.contactId;
        setControlValue(this.form.group, 'customerName', contact.name);
      });
  }

  protected buildForm(snapshot: FormStateSnapshot<JobSpecInfo>): FormState<JobSpecInfo> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      snapshot,
      children: {
        jobNumber: { enabled: false },
        name: { enabled: false },
        customerName: { enabled: false },
      },
    });
  }
}
